import Location from 'root/blackcard/util/location/index';
import env from './env';
import * as addressService from 'root/blackcard/modules/address';
import { getUserDistrictFn } from '../modules/location';
import storage from 'root/common/util/storage.js';
import keyConfig from 'root/common/const/localStorageKey.js';
import locationUtil from 'root/blackcard/util/location/locationUtil';
/**
 * 获取当前的位置
 * @param {} timeout
 */
export function getCurrentLocation(timeout = 5000) {
    return new Promise(resolve => {
        // 5秒超时
        setTimeout(() => {
            console.log('getUserCity getLocation timeout');
            resolve(null);
        }, timeout);

        const location = new Location(env);

        location
            .getLocation()
            .then(position => {
                resolve(position);
            })
            .catch(err => {
                // 用户拒绝授权
                console.log('getUserCity getLocation fail', err);
                resolve(null);
            });
    });
}

/**
 * 获取定位，并返回城市
 */
export async function getUserCityByPosition() {
    console.log('getUserCity getLocation');
    let position = await getCurrentLocation();

    // res = { latitude: 39.8260050000,longitude : 116.8205610000 }
    // position = { latitude: 30.2427011, longitude: 120.1502699 };

    let positionCity = null;
    if (position) {
        console.log('getLocation success', position);
        let data = {
            lng: position.longitude,
            lat: position.latitude,
            ptype: 'city,county,province',
        };

        const res = await addressService.getCityByPosition(data);
        if (res.Code !== 0 || !res.Message || !res.Message.length) {
            if (window.monitor) {
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    msg: `getCityByPosition error: ${position.longitude},${position.latitude}`,
                });
            }
            return null;
        }
        // 依次分别对应正常的市,直辖市,直辖县
        const city =
            res.Message.find(el => el.place_type === 'city') ||
            res.Message.find(el => el.place_type === 'province') ||
            res.Message.find(el => el.place_type === 'county');
        if (!city) {
            if (window.monitor) {
                window.monitor.report({
                    level: 'info',
                    error: 'js',
                    msg: `getCityByPosition error: ${position.longitude},${position.latitude}`,
                });
            }
            return null;
        }
        positionCity = Object.assign(city, {
            id: String(city.city_id),
            cityCn: city.city_cn,
            stateCn: city.state_cn,
            countryCn: city.country_cn,
            timestamp: Date.now(),
            lat: position.latitude,
            lng: position.longitude,
        });
        locationUtil.setPositionCityCache(positionCity);
        return positionCity;
    }
    return positionCity;
}

/**
 * 获取当前的城市数据
 * @param {}} configData
 */
export async function getUserCity(configData) {
    console.log('getUserCity', configData);
    let res = await getUserCityByPosition();

    // 若拿到地理地址
    if (res) {
        const isHidden = matchCity(configData.citys, res.cityCn);
        // {"fence":[5],"privilegeResultText":["省钱宝"]}
        return isHidden ? { ...configData.otherSettingObj, cityId: res.id } : { fence: [], privilegeResultText: [] };
    } else {
        // 拿不到则用接口返回的结果
        const isHidden = matchCity(configData.citys, configData.nowCity);
        return isHidden ? configData.otherSettingObj : { fence: [], privilegeResultText: [] };
    }
}

function matchCity(CityList, cityName) {
    return (
        CityList.findIndex(item => {
            return cityName.indexOf(item) > -1;
        }) > -1
    );
}
// 通过ip获取app
// 获取用户IP及屏蔽城市
export async function getUserHiddenDistrict() {
    let config = await getUserDistrictFn();

    if (config.code == 200) {
        if (config.data.otherSetting) {
            config.data.otherSettingObj = JSON.parse(config.data.otherSetting);
        }
        if (!config.data.rebateSwitch) return { fence: [], privilegeResultText: [] };
        return await getUserCity(config.data);
    } else {
        return false;
    }
}

// 单页获取定位,用于苏宁商品数据获取
export async function globalGetUserCity() {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
        setTimeout(() => {
            // 超出3s 则取默认
            resolve(false);
        }, 3000);
        const result = await getUserCityByPosition().catch(() => {
            resolve(false);
        });
        console.log('地址：', result);
        // 获取不到地址，记录下来，24小时内不再发起获取定位
        if (result == null)
            storage.set(
                keyConfig['getUserLocationFailFlag'],
                {
                    timestamp: new Date().getTime(),
                },
                60 * 60 * 24
            );
        resolve(result);
    });
}

/**
 * 获取用户当前城市，如果缓存有则取缓存，否则重新定位
 * @param {Object} param0
 * @param {Number} param0.cacheTime 毫秒，缓存时间，如果超过这个时间则重新获取
 */
export async function getUserCityByCacheOrLocation({ cacheTime } = { cacheTime: 3600 * 1000 }) {
    let positionObj = locationUtil.getPositionCityCache();
    if (!positionObj || !positionObj.timestamp || new Date().getTime() - positionObj.timestamp > cacheTime) {
        return globalGetUserCity();
    }
    return positionObj;
}

// 检测FencId是否需要屏蔽返现
export function chechFeedbackHidden(fenceId) {
    const feedBackHidden = storage.get(keyConfig['feedBackHidden']);
    if (feedBackHidden) {
        const isIncludes = feedBackHidden.fence.includes(+fenceId);
        return isIncludes;
    }
    return false;
}
// getUserDistrict().then(res=>{
//     console.log(res)
// })
